  import React from "react";
import Select from '../../../../library/ReactSelect';

const ProgressFieldsStandardReReg = ({articulationDropdown,disabled,formik, progressId, setProgressId }) => {
    return <>
    <div className='card-header'>Programme Articulation</div>
    {[1].map((item, index) => (
        <div className="row align-items-center mb-4" key={index}>
        <div className="col-md-3">        
        </div>
        <div className="col-md-4">
        <div className="form-icon-group">
        <Select
        className="form-control custom-select-box"
        name={`Progess${item}`}
        isDisabled={disabled}
        value={
            (articulationDropdown || []).filter(
                (data) =>
                    progressId && progressId == data.value
            )
        }
        onChange={(value) => {
            setProgressId(value ? value.value : "");
            formik.setFieldValue('progress_q1', value ? value.value : "");
            if(value){
                formik.setFieldValue('foundation', true);
                formik.setFieldValue('student_type', 1);
            }else{
                formik.setFieldValue('foundation', false);
                formik.setFieldValue('student_type', 0);
            }
        }}
        isClearable
        onBlur={formik.handleBlur}
        options={articulationDropdown}
        maxMenuHeight={175}
        placeholder={
            progressId ? progressId: "Select"
        }
        />
        </div>
        </div>
        </div>
    ))}
    </>;
};

export default ProgressFieldsStandardReReg;
